import storageActions from 'app/utils/storageActions'
import filterHelpers from 'app/utils/filterHelpers'

const initialState = filterHelpers.defaultFilters()

export const filters = (state = initialState, action) => {
  switch (action.type) {
    case 'filters/update': {
      const filters = {
        ...state,
        ...action.filters,
      }
      if(!action.temporary){
        storageActions.saveItem('filters', filters)
      }
      return {
        ...filters,
      }
    }
    case 'filter/update': {
      const filters = {
        ...state,
        [action.key]: action.value,
      }
      if(!action.temporary){
        storageActions.saveItem('filters', filters)
      }
      return {
        ...filters,
      }
    }
    default:
      return state
  }
}